import { useMemo } from 'react'
import { DrawControllerWrapper } from '@scene'
import { useCameraStore } from '@modugen/ui-toolkit'
import { publishCoordinateEvent } from '@ui/events'
import { useControlStore, useSelectionStore } from '@editorStores'
import { useClickActionEnabled } from '@editorHooks'
import { useModelSnapTargets } from 'src/components/pages/Editor/pages/StructuralPlanning/components/FloorplanDrawer/hooks'
import useCommentSnapTargets from 'src/components/scene/hooks/useCommentSnapTargets'
import useTapelineCentersSnapTargets from 'src/components/scene/hooks/useTapelineCentersSnapTargets'
import useTapelineSnapTargets from 'src/components/scene/hooks/useTapelineSnapTargets'

const CoordinateExplorerScene = () => {
  const snapToCornersAndEdges = useControlStore(state => state.snapToCornersAndEdges)
  const snapOrthogonal = useControlStore(state => state.snapOrthogonal)
  const snapToAngles = useControlStore(state => state.snapToAngles)
  const setCoordinateExplorerEnabled = useControlStore(state => state.setCoordinateExplorerEnabled)
  const snapToComments = useControlStore(state => state.snapToComments)
  const isOrthographic = useCameraStore(state => state.isOrthographic)
  const modelSnapTargets = useModelSnapTargets({ xyOnly: isOrthographic })
  const tapelineSnapTargets = useTapelineSnapTargets(isOrthographic)
  const tapelineCenterTargets = useTapelineCentersSnapTargets(isOrthographic)
  const commentSnapTargets = useCommentSnapTargets(isOrthographic)
  // Narrow selector — avoids re-rendering on unrelated selection store changes.
  const isCommentsMode = useSelectionStore(state => state.mode === 'comments')

  const additionalSnapTargets = useMemo(() => {
    return [
      ...modelSnapTargets,
      ...tapelineSnapTargets,
      ...tapelineCenterTargets,
      ...(snapToComments && isCommentsMode ? commentSnapTargets : []),
    ]
  }, [
    modelSnapTargets,
    tapelineSnapTargets,
    tapelineCenterTargets,
    commentSnapTargets,
    snapToComments,
    isCommentsMode,
  ])

  const drawControllerEnabled = useClickActionEnabled({ disableOnCoordinateInputFocused: false })

  return (
    <DrawControllerWrapper
      enabled={drawControllerEnabled}
      enableIndicator
      xyOnly={isOrthographic}
      snapToAngles={snapToAngles}
      orthoSnap={snapOrthogonal}
      additionalSnapTargets={additionalSnapTargets}
      snapToCornersAndEdges={snapToCornersAndEdges}
      onDrawEnd={state => {
        if (state.drawPoint) {
          publishCoordinateEvent({
            x: state.drawPoint.x,
            y: state.drawPoint.y,
            z: state.drawPoint.z,
          })
        }

        setCoordinateExplorerEnabled(false)
      }}
    />
  )
}

export default CoordinateExplorerScene
